var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconFullscreenExit(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon_fullscreen_exit",
    transform: "translate(-1586 -196)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2930",
    "data-name": "Rectangle 2930",
    width: 24,
    height: 24,
    transform: "translate(1586 196)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6754",
    "data-name": "Path 6754",
    d: "M441.375-166a.377.377,0,0,1-.375-.375v-3.876a.749.749,0,0,1,.75-.75h3.876a.377.377,0,0,1,.375.375v1.25a.377.377,0,0,1-.375.375H443v2.625a.377.377,0,0,1-.375.375Zm-6,0a.377.377,0,0,1-.375-.375V-169h-2.625a.377.377,0,0,1-.375-.375v-1.25a.377.377,0,0,1,.375-.375h3.875a.749.749,0,0,1,.751.75v3.876a.377.377,0,0,1-.375.375Zm6.374-9a.749.749,0,0,1-.75-.751v-3.875a.377.377,0,0,1,.375-.375h1.25a.377.377,0,0,1,.375.375V-177h2.625a.377.377,0,0,1,.375.375v1.25a.377.377,0,0,1-.375.375Zm-9.374,0a.377.377,0,0,1-.375-.375v-1.251a.377.377,0,0,1,.375-.374H435v-2.625a.377.377,0,0,1,.375-.375h1.25a.377.377,0,0,1,.375.375v3.875a.75.75,0,0,1-.751.751Z",
    transform: "translate(1159 381)",
    fill: "#171c28"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFullscreenExit);
export default __webpack_public_path__ + "static/media/icon_fullscreen_exit.58811b97.svg";
export { ForwardRef as ReactComponent };